import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import ContactPage from "../pages/contact/page";
import TechPage from "../pages/tech/page";
import XRPage from "../pages/xr/page";
import XRDetailPage from "../pages/xr/detail/page";
import MarsPage from "../pages/mars/page";
import MarsDetailPage from "../pages/mars/detail/page";
import MetaVisionPage from "../pages/meta-vision/page";
import DigitalAssetsPage from "../pages/digital-assets/page";
import NexusPage from "../pages/nexus/page";
import NetworkPage from "../pages/network/page";
import NetworkDetailPage from "../pages/network/detail/page";
import FutureTechPage from "../pages/future-tech/page";
import FutureTechDetailPage from "../pages/future-tech/detail/page";
import AboutPage from "../pages/about/page";
import ShopPage from "../pages/shop/page";
import StoryPage from "../pages/story/page";
import StoryUploadPage from "../pages/story-upload/page";
import OmniverseMallPage from "../pages/omniverse-mall/page";
import OmniverseProductsPage from "../pages/omniverse-mall/products/page";
import OmniverseProductDetailPage from "../pages/omniverse-mall/product/page";
import OmniverseZonePage from "../pages/omniverse-mall/zone/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/news", element: <NewsPage /> },
  { path: "/news/:id", element: <NewsDetailPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/tech/*", element: <TechPage /> },
  { path: "/xr", element: <XRPage /> },
  { path: "/xr/:id", element: <XRDetailPage /> },
  { path: "/mars", element: <MarsPage /> },
  { path: "/mars/:id", element: <MarsDetailPage /> },
  { path: "/meta-vision", element: <MetaVisionPage /> },
  { path: "/digital-assets", element: <DigitalAssetsPage /> },
  { path: "/nexus", element: <NexusPage /> },
  { path: "/network", element: <NetworkPage /> },
  { path: "/network/:id", element: <NetworkDetailPage /> },
  { path: "/future-tech", element: <FutureTechPage /> },
  { path: "/future-tech/:id", element: <FutureTechDetailPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/story/:id", element: <StoryPage /> },
  { path: "/story-upload", element: <StoryUploadPage /> },
  { path: "/omniverse-mall", element: <OmniverseMallPage /> },
  { path: "/omniverse-mall/products", element: <OmniverseProductsPage /> },
  { path: "/omniverse-mall/product/:id", element: <OmniverseProductDetailPage /> },
  { path: "/omniverse-mall/zone/:zoneId", element: <OmniverseZonePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
